import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';
import axios from '../modules/AxiosInstance';

const EmailService = (() => {
  const service = {};
  const BASE_URL = Environment.getBaseURL();

  service.getEmails = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(criteria);

    return axios.get(`${BASE_URL}/email/search${queryString}`, {
      headers,
    });
  };

  service.resendEmail = (emailId, recipientsList) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const recipients = recipientsList.map(recipient => ({ emailAddress: recipient[0], customerId: recipient[1], }));
    const emailResubmissionRequest = {
      emailId,
      recipients,
    };

    return axios.post(
      `${BASE_URL}/email/resend-email`,

      emailResubmissionRequest,

      {
        headers,
      }
    );
  };

  return service;
})();

export default EmailService;
